export const FloatingModalChunk = () =>
    import(/* webpackChunkName: 'listings/store-builder-floating-modal' */ '@fiverr-private/store_builder_ui').then(
        (mod) => ({ default: mod.FloatingModal })
    );

export const RecommendationsCarouselsChunk = () =>
    import(/* webpackChunkName: 'listings/recommendations-carousels' */ '../recommendations/Carousels');
